import instance from "../axios";

export const getAll = async ({ dateFrom, dateTo, userID } = {}) => {
  const params = {};

  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  if (userID) params.userID = userID;

  const response = await instance.get(`work-plans`, { params });
  return response.data;
};
export const getDetails = async (id) => {
  const response = await instance.get(`work-plans/` + id);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`work-plans`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`work-plans`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`work-plans/` + id);
  return response;
};
